import apiSlice from "./ApiSlice";

const FuturePurchaseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllFuturePurchaseData: builder.query({
      providesTags: ["future-purchase"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/future-purchase",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteFuturePurchaseById: builder.mutation({
      invalidatesTags: ["future-purchase"],
      query: (id: any) => ({
        url: `/future-purchase/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addFuturePurchase: builder.mutation({
      invalidatesTags: ["future-purchase"],
      query: (body) => ({
        url: `/future-purchase/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getFuturePurchaseById: builder.query({
      providesTags: ["future-purchase"],
      query: (id) => {
        return {
          url: `/future-purchase/${id}`,
          method: "GET",
        };
      },
    }),
    getAllFuturePurchaseExcelData: builder.mutation({
      invalidatesTags: ["future-purchase"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/future-purchase",
          method: "POST",
          body,
        };
      },
    }),
    // update delivery date
    updateFuturePurchaseById: builder.mutation({
      invalidatesTags: ["future-purchase"],
      query: ({ body, id }) => ({
        url: `/future-purchase/${id}`,
        method: "PUT",
        body,
      }),
    }),

    //get FuturePurchase
    getAllFuturePurchase: builder.query({
      providesTags: ["future-purchase"],
      query: () => {
        return {
          url: `/future-purchase`,
          method: "GET",
        };
      },
    }),

    // change status of delivery date
    changeStatusFuturePurchaseById: builder.mutation({
      invalidatesTags: ["future-purchase"],
      query: ({ body, id }) => ({
        url: `/future-purchase/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllFuturePurchaseDataQuery,
  useDeleteFuturePurchaseByIdMutation,
  useAddFuturePurchaseMutation,
  useGetAllFuturePurchaseQuery,
  useGetFuturePurchaseByIdQuery,
  useUpdateFuturePurchaseByIdMutation,
  useChangeStatusFuturePurchaseByIdMutation,
  useGetAllFuturePurchaseExcelDataMutation
} = FuturePurchaseApi;
